import React, {forwardRef} from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import {BasicIconButton} from './basic-icon-button.component';
import {SIZES, SIZES_CLASSES} from './constants';
import styles from './icon-button.component.module.styl';

import type {BasicIconButtonProps} from './basic-icon-button.component';


const classNames = withCssModule(styles);

export interface IconButtonProps extends BasicIconButtonProps {
    /**
     * Button size
     */
    size?: SIZES,
    /**
     * Selected button state
     */
    selected?: boolean,
    /**
     * Flat button view
     */
    flat?: boolean,
    /**
     * ref to the element
     */
    ref?: React.Ref<HTMLButtonElement>,
}

/**
 * @see [Storybook]{@link
 * https://storybook.dev.pitchbookdata.com/?path=/docs/components-icon-button--default-icon-buttons-template}
 */
export const IconButton = forwardRef<HTMLButtonElement | HTMLAnchorElement, IconButtonProps>(
    function IconButton(props, ref) {
        const {
            className,
            mix,
            flat,
            size = SIZES.NONE,
            selected,
            ...otherProps
        } = props;

        const iconButtonClasses = classNames(
            'icon-button_button',
            className,
            mix,
            SIZES_CLASSES[size],
            {
                'icon-button_selected': selected,
                'icon-button_flat': flat,
            },
        );

        return (
            <BasicIconButton
                aria-pressed={selected !== undefined ? selected : undefined}
                {...otherProps}
                className={iconButtonClasses}
                ref={ref}
            />
        );
    },
);

IconButton.displayName = 'IconButton';
